module.exports = __webpack_public_path__ + "img/柚子10.d5e98688.png";